import { render, staticRenderFns } from "./sources.vue?vue&type=template&id=70f61b3f&scoped=true&"
import script from "./sources.vue?vue&type=script&lang=js&"
export * from "./sources.vue?vue&type=script&lang=js&"
import style0 from "./sources.vue?vue&type=style&index=0&id=70f61b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f61b3f",
  null
  
)

export default component.exports